<template>
  <div>
    <!-- <div class='top'> -->
      <!-- <img @click="preview" :src='tenant.logoUrl? tenant.logoUrl : defaultLogoImg'> -->
      <!-- <div>
        <div>
            <span>最近的门店</span>
            <p class="storeName">{{tenant.name}}</p>
		        <img @click="makePhoneCall" class="storePhone" src='../imgs/telephone.svg'>
         </div>
         <div>
           <p>{{tenant.location}} </p>
           <span v-if="tenant.distance">距离{{tenant.distance}}</span>
         </div>
      </div> -->
      <div class="exchange" @click="changeTenant">
        <span class="storeName">{{tenant.name}}</span>
        <img src='../imgs/exchange.svg'>
      </div>
    <!-- </div> -->
    <van-image-preview
      v-model="showPreview"
      :images="[tenant.logoUrl]"
      closeable
    />
  </div>
</template>

<script>
import { doFormPost } from '@/utils/request';
import { ImagePreview } from 'vant';
// 门店小程序头部切换门店的组件
export default {
  name:'switchShop',
  components:{
    [ImagePreview.Component.name]: ImagePreview.Component,
  },
  props: {
    // 切换门店完成后的回跳路径
    returnPath: {
      type: String,
      default: function(){
        return 'index'
      }
    }
  },
  data() {
    return {
      tenant:{},
      defaultLogoImg: 'https://xls.36588.com/static/image/user.svg',
      showPreview: false,
    }
  },
  mounted() {
    this.initTenantData()
  },
  methods: {
    changeTenant(){
      if(this.returnPath==='cart'){
        this.sendRecord('click_on_the_shopping_cart_to_switch_stores',{page:'切换门店'})
      }else{
        this.sendRecord('click_to_switch_stores',{page:'切换门店'})
      }
      wx.miniProgram.reLaunch({
        url: '/pages/index/viewIndex?fromPage=' + this.returnPath
      })
    },
    initTenantData(){
      doFormPost('/newRetail/querTenantInfo',{},res => {
        if(res.result == 'success'){
          this.tenant = res.userData
        }
      })
    },
    makePhoneCall(){
      this.sendRecord('click_the_call_icon',{page:'切换门店'})
      wx.miniProgram.navigateTo({
        url: '/pages/mshop/makePhoneCall?phoneNumber=' + this.tenant.contactPhone
      })
    },
    preview(){
      if(this.tenant.logoUrl){
        this.showPreview = true
      }
    }
  },
}
</script>

<style scoped>
/* .top{
  padding:8px 12px;
  background:#fff;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
} */
.exchange>img{
  width:20px;
  border-radius:50%;
  padding: 2px 0;
  vertical-align: bottom;
}
/* .top>div:nth-child(2){
  width:calc(100% - 120px);
}
.top>div:nth-child(2) div{
  overflow:hidden;
  font-size:14px;
  line-height: 24px;
}
.top p{
  margin:0;
  color:#606266;
  display: inline-block;
}
.top .storeName{
  color: #303133;
  font-weight: bold;
  line-height: 24px;
}
.top .storePhone{
  width: 20px;
  height: 20px;
  margin-left: 8px;
  vertical-align: text-bottom;
}
.top>div:nth-child(2) div:last-child{
  line-height:16px;
} */
/* .top>div:nth-child(2) div:last-child p{
  color:#909399;
  margin-left:0;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;  /* 超出n行这里写n */
  /* -webkit-box-orient: vertical;
  line-height: 16px;
  font-size: 12px; */
/* } */ 
.exchange{
  background:rgba(255, 255, 255, .8);
  /* max-width:96px; */
  border-radius: 0 20px 20px 0;
  color:#606266;
  font-size: 12px;
  position: fixed;
  left: 0;
  bottom: 112px;
  z-index: 9;
  box-shadow: 0 0 5px rgba(0, 0, 0, .2);
  padding: 2px 4px;
}
.storeName{
  display: inline-block;
  overflow:hidden;
  text-overflow:ellipsis;
  white-space:nowrap;
  width:64px;
}
/* .top>div:nth-child(2) div:last-child img{
  float:left;
}
.top>div:last-child{
  background:#FF0036;
  height:32px;
  border-radius:5px;
  color:#fff;
  line-height:32px;
  padding:0 8px;
}
.top>div:last-child img{
  float:left;
  margin-top:5px;
}
.top>div:last-child span{
  color:#fff;
} */
</style>



// WEBPACK FOOTER //
// src/templates/components/switchShop.vue